import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoaderComponent } from '@shared/loader/loader.component';
import { HomeExpertCardViewModel } from '../home.models';

@Component({
  selector: 'app-home-experts-section',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './home-experts-section.component.html',
})
export class HomeExpertsSectionComponent {
  @Input() expertCards: HomeExpertCardViewModel[] = [];
  @Input() isLoading = false;
  @Input() activeCount = 0;
  @Input() totalCount = 0;

  @Output() expertSelected = new EventEmitter<HomeExpertCardViewModel>();

  onExpertSelected(expert: HomeExpertCardViewModel): void {
    if (expert.disabled) {
      return;
    }

    this.expertSelected.emit(expert);
  }
}
